import React, { useState, useEffect } from 'react';
import HeaderOne from "../components/header/HeaderOne";
import Breadcrumb from "./Breadcrumb";
import { Link } from 'react-router-dom';
import FooterOne from "../components/footer/FooterOne";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, A11y, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import Accordion from 'react-bootstrap/Accordion';



function QuiSommesNous() {
    const breadcrumbs = [
        { label: 'Accueil', link: '/' },
        { label: 'Qui sommes-nous' }
    ];
    return (
        <div className=''>

            <HeaderOne />
            <Breadcrumb title="Qui sommes-nous" breadcrumbs={breadcrumbs} />
            {/* rts about us section start */}
            <div className="rts-about-area rts-section-gap">
                <div className="container">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6">
                            <img
                                src="assets/images/quisomme1.jpeg"
                                alt="GLOBAL-SERVICES_CONGO"
                                style={{ maxWidth: '100%', height: 'auto', objectFit: 'contain' }}
                            />
                        </div>
                        <div className="col-lg-6">
                            <div className="about-progress-inner">
                                <div className="title-area">
                                    <span>La nouvelle marque d'Entrepreneuriat</span>
                                </div>
                                {/* inner start */}
                                <div className="inner">
                                    <p className="disc" style={{ textAlign: 'justify' }}>
                                        GLOBAL-SERVICES CONGO Sarlu (GSC Sarlu) est une société de prestations de services destinée aux professionnels, établie à Pointe-Noire, capitale économique du Congo. L'entreprise propose des services de qualité avec une priorité sur la satisfaction du client.
                                    </p>
                                    <p className="disc" style={{ textAlign: 'justify' }}>
                                        Notre savoir-faire repose sur nos valeurs, notre éthique, nos compétences, un personnel expérimenté, rigoureux et qualifié. GSC Sarlu accompagne les entreprises dans leurs projets, identifie leurs besoins et propose des solutions personnalisées.
                                    </p>
                                    <div className="rts-progress-one-wrapper">
                                        <div className="single-progress">
                                            <div className="progress-top">
                                                <p className="progress-title">Satisfaction client</p>
                                                <span className="persectage">95%</span>
                                            </div>
                                            <div className="meter cadetblue">
                                                <span data-progress={95} style={{ width: 400 }} />
                                            </div>
                                        </div>
                                        <div className="single-progress">
                                            <div className="progress-top">
                                                <p className="progress-title">Expertise professionnelle</p>
                                                <span className="persectage">100%</span>
                                            </div>
                                            <div className="meter">
                                                <span data-progress={100} style={{ width: 400 }} />
                                            </div>
                                        </div>
                                    </div>
                                    <Link to={'/contactus'} className="rts-btn btn-primary">
                                        Nous contacter
                                    </Link>
                                </div>
                                {/* end */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* rts about us section end */}


            {/* rts services area start */}
            <div className="rts-service-area rts-section-gapBottom">
                <div className="container-fluid service-main about-service-width-controler">
                    <div className="background-service service-three row">
                        <div className="row g-5">
                            <div className="rts-title-area service-four text-center pt--40 pt_md--0 mt_sm--0 mt_md--0">
                                <p className="pre-title">Nos Services</p>
                                <h2 className="title">Domaines d'activités</h2>
                            </div>
                            <div className="col-12 pt--15">
                                <Swiper
                                    modules={[Navigation, A11y, Autoplay]}
                                    spaceBetween={30}
                                    slidesPerView={1}
                                    navigation={{
                                        nextEl: '.swiper-button-next-services',
                                        prevEl: '.swiper-button-prev-services',
                                    }}
                                    autoplay={{
                                        delay: 3000,
                                        disableOnInteraction: false,
                                    }}
                                    loop={true}
                                    breakpoints={{
                                        1200: { slidesPerView: 3 },
                                        992: { slidesPerView: 2 },
                                        768: { slidesPerView: 2 },
                                        576: { slidesPerView: 1 },
                                        0: { slidesPerView: 1 },
                                    }}
                                    className="services-swiper"
                                >
                                    <SwiperSlide>
                                        <div className="service-one-inner-four">
                                            <div className="big-thumbnail-area">
                                                <Link to={'/service/prestations-service-on-off-shore'} className="thumbnail">
                                                    <img
                                                        src="/assets/images/prestation.jpeg"
                                                        alt="Prestation de services On/Off Shore"
                                                    />
                                                </Link>
                                                <div className="content">
                                                    <img
                                                        src="/assets/images/service/icon/13.svg"
                                                        alt="Business-icon"
                                                    />
                                                    <h5 className="title">Prestation de services On/Off Shore</h5>
                                                    <p className="disc">
                                                        Externalisation d'activités pétrolières en mer et à terre pour optimiser votre fonctionnement
                                                    </p>
                                                </div>
                                                <Link to={'/service/prestations-service-on-off-shore'} className="over_link" />
                                            </div>
                                            <Link to={'/service/prestations-service-on-off-shore'} className="rts-btn btn-primary">
                                                {" "}
                                                En savoir plus
                                                <i className="fal fa-arrow-right" />
                                            </Link>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="service-one-inner-four">
                                            <div className="big-thumbnail-area">
                                                <Link to={'/service/transit'} className="thumbnail">
                                                    <img
                                                        src="/assets/images/transit.jpeg"
                                                        alt="Transit"
                                                    />
                                                </Link>
                                                <div className="content">
                                                    <img
                                                        src="/assets/images/service/icon/14.svg"
                                                        alt="Business-icon"
                                                    />
                                                    <h5 className="title">Transit</h5>
                                                    <p className="disc">
                                                        Traçabilité permanente, respect des procédures internationales et coordination complète
                                                    </p>
                                                </div>
                                                <Link to={'/service/transit'} className="over_link" />
                                            </div>
                                            <Link to={'/service/transit'} className="rts-btn btn-primary">
                                                {" "}
                                                En savoir plus
                                                <i className="fal fa-arrow-right" />
                                            </Link>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="service-one-inner-four">
                                            <div className="big-thumbnail-area">
                                                <Link to={'/service/fourniture-materiaux-construction'} className="thumbnail">
                                                    <img
                                                        src="/assets/images/fourniture.jpeg"
                                                        alt="Fourniture de matériaux de construction"
                                                    />
                                                </Link>
                                                <div className="content">
                                                    <img
                                                        src="/assets/images/service/icon/15.svg"
                                                        alt="Business-icon"
                                                    />
                                                    <h5 className="title">Fourniture de matériaux de construction</h5>
                                                    <p className="disc">
                                                        Approvisionnement en matériaux de construction de qualité pour tous vos projets avec livraison rapide
                                                    </p>
                                                </div>
                                                <Link to={'/service/fourniture-materiaux-construction'} className="over_link" />
                                            </div>
                                            <Link to={'/service/fourniture-materiaux-construction'} className="rts-btn btn-primary">
                                                {" "}
                                                En savoir plus
                                                <i className="fal fa-arrow-right" />
                                            </Link>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="service-one-inner-four">
                                            <div className="big-thumbnail-area">
                                                <Link to={'/service/construction-btp-genie-civil'} className="thumbnail">
                                                    <img
                                                        src="/assets/images/btp.jpeg"
                                                        alt="Construction BTP & Génie civil"
                                                    />
                                                </Link>
                                                <div className="content">
                                                    <img
                                                        src="/assets/images/service/icon/15.svg"
                                                        alt="Business-icon"
                                                    />
                                                    <h5 className="title">Construction BTP &amp; Génie civil</h5>
                                                    <p className="disc">
                                                        Construction, rénovation et aménagement avec engagement de qualité, fiabilité et respect des délais
                                                    </p>
                                                </div>
                                                <Link to={'/service/construction-btp-genie-civil'} className="over_link" />
                                            </div>
                                            <Link to={'/service/construction-btp-genie-civil'} className="rts-btn btn-primary">
                                                {" "}
                                                En savoir plus
                                                <i className="fal fa-arrow-right" />
                                            </Link>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="service-one-inner-four">
                                            <div className="big-thumbnail-area">
                                                <Link to={'/service/fourniture-equipements-industriels'} className="thumbnail">
                                                    <img
                                                        src="/assets/images/industrie.jpeg"
                                                        alt="Fourniture d'équipements industriels"
                                                    />
                                                </Link>
                                                <div className="content">
                                                    <img
                                                        src="/assets/images/service/icon/16.svg"
                                                        alt="Business-icon"
                                                    />
                                                    <h5 className="title">Fourniture d'équipements industriels</h5>
                                                    <p className="disc">
                                                        Solutions complètes en équipements industriels adaptés à vos besoins avec installation et maintenance
                                                    </p>
                                                </div>
                                                <Link to={'/service/fourniture-equipements-industriels'} className="over_link" />
                                            </div>
                                            <Link to={'/service/fourniture-equipements-industriels'} className="rts-btn btn-primary">
                                                {" "}
                                                En savoir plus
                                                <i className="fal fa-arrow-right" />
                                            </Link>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="service-one-inner-four">
                                            <div className="big-thumbnail-area">
                                                <Link to={'/service/nettoyage-industriel-assainissement'} className="thumbnail">
                                                    <img
                                                        src="/assets/images/nettoyage.jpeg"
                                                        alt="Nettoyage industriel & assainissement"
                                                    />
                                                </Link>
                                                <div className="content">
                                                    <img
                                                        src="/assets/images/service/icon/17.svg"
                                                        alt="Business-icon"
                                                    />
                                                    <h5 className="title">Nettoyage industriel &amp; assainissement</h5>
                                                    <p className="disc">
                                                        Services de nettoyage industriel et assainissement pour maintenir vos espaces de travail propres et sécurisés
                                                    </p>
                                                </div>
                                                <Link to={'/service/nettoyage-industriel-assainissement'} className="over_link" />
                                            </div>
                                            <Link to={'/service/nettoyage-industriel-assainissement'} className="rts-btn btn-primary">
                                                {" "}
                                                En savoir plus
                                                <i className="fal fa-arrow-right" />
                                            </Link>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="service-one-inner-four">
                                            <div className="big-thumbnail-area">
                                                <Link to={'/service/fourniture-equipement-general'} className="thumbnail">
                                                    <img
                                                        src="/assets/images/fourniture_entreprise.jpeg"
                                                        alt="Fourniture d'équipement général"
                                                    />
                                                </Link>
                                                <div className="content">
                                                    <img
                                                        src="/assets/images/service/icon/18.svg"
                                                        alt="Business-icon"
                                                    />
                                                    <h5 className="title">Fourniture d'équipement général</h5>
                                                    <p className="disc">
                                                        Équipement complet pour votre entreprise avec sélection de matériels adaptés et solutions sur mesure
                                                    </p>
                                                </div>
                                                <Link to={'/service/fourniture-equipement-general'} className="over_link" />
                                            </div>
                                            <Link to={'/service/fourniture-equipement-general'} className="rts-btn btn-primary">
                                                {" "}
                                                En savoir plus
                                                <i className="fal fa-arrow-right" />
                                            </Link>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="service-one-inner-four">
                                            <div className="big-thumbnail-area">
                                                <Link to={'/service/mise-disposition-personnel'} className="thumbnail">
                                                    <img
                                                        src="/assets/images/disposition1.jpeg"
                                                        alt="Mise à disposition de personnel"
                                                    />
                                                </Link>
                                                <div className="content">
                                                    <img
                                                        src="/assets/images/service/icon/19.svg"
                                                        alt="Business-icon"
                                                    />
                                                    <h5 className="title">Mise à disposition de personnel</h5>
                                                    <p className="disc">
                                                        Mise à disposition de personnel qualifié et expérimenté pour répondre à vos besoins temporaires ou permanents
                                                    </p>
                                                </div>
                                                <Link to={'/service/mise-disposition-personnel'} className="over_link" />
                                            </div>
                                            <Link to={'/service/mise-disposition-personnel'} className="rts-btn btn-primary">
                                                {" "}
                                                En savoir plus
                                                <i className="fal fa-arrow-right" />
                                            </Link>
                                        </div>
                                    </SwiperSlide>
                                    <SwiperSlide>
                                        <div className="service-one-inner-four">
                                            <div className="big-thumbnail-area">
                                                <Link to={'/service/transport-logistique'} className="thumbnail">
                                                    <img
                                                        src="/assets/images/transport.jpeg"
                                                        alt="Transport & logistique"
                                                    />
                                                </Link>
                                                <div className="content">
                                                    <img
                                                        src="/assets/images/service/icon/20.svg"
                                                        alt="Business-icon"
                                                    />
                                                    <h5 className="title">Transport &amp; logistique</h5>
                                                    <p className="disc">
                                                        Solutions complètes de transport et logistique pour optimiser vos chaînes d'approvisionnement avec suivi en temps réel
                                                    </p>
                                                </div>
                                                <Link to={'/service/transport-logistique'} className="over_link" />
                                            </div>
                                            <Link to={'/service/transport-logistique'} className="rts-btn btn-primary">
                                                {" "}
                                                En savoir plus
                                                <i className="fal fa-arrow-right" />
                                            </Link>
                                        </div>
                                    </SwiperSlide>
                                </Swiper>
                                <div className="swiper-navigation-services text-center mt--40" style={{ display: 'flex', justifyContent: 'center', gap: '20px', alignItems: 'center' }}>
                                    <button 
                                        className="swiper-button-prev-services rts-btn btn-primary"
                                        style={{ width: '50px', height: '50px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', cursor: 'pointer' }}
                                    >
                                        <i className="fal fa-arrow-left" />
                                    </button>
                                    <button 
                                        className="swiper-button-next-services rts-btn btn-primary"
                                        style={{ width: '50px', height: '50px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', cursor: 'pointer' }}
                                    >
                                        <i className="fal fa-arrow-right" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* rts services area End */}


            <FooterOne />

        </div>
    )
}

export default QuiSommesNous

